import {
  createInstructor as publicCreateInstructor,
  inviteInstructor as publicInviteInstructor,
  listInstructors as publicListInstructors,
  queryInstructors as publicQueryInstructors,
  typedQueryInstructors as publicTypedQueryInstructors,
  updateInstructor as publicUpdateInstructor,
  deleteInstructor as publicDeleteInstructor,
  assignInstructorToProgram as publicAssignInstructorToProgram,
  unassignInstructorFromProgram as publicUnassignInstructorFromProgram,
  changeProgramInstructors as publicChangeProgramInstructors,
} from './achievements-instructors-v2-instructor-instructors.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';
import { HttpClient } from '@wix/sdk-types';
import { createQueryOverloadRouter } from '@wix/sdk-runtime/query-method-router';
import {
  InstructorQuery,
  InstructorsQueryBuilder,
  typedQueryInstructors as universalTypedQueryInstructors,
} from './achievements-instructors-v2-instructor-instructors.universal.js';

function customQueryInstructors(httpClient: HttpClient) {
  const router = createQueryOverloadRouter({
    builderQueryFunction: () => publicQueryInstructors(httpClient)(),
    typedQueryFunction: (query: InstructorQuery) =>
      publicTypedQueryInstructors(httpClient)(query),
    hasOptionsParameter: false,
  });

  function overloadedQuery(): InstructorsQueryBuilder;
  function overloadedQuery(
    query: InstructorQuery
  ): ReturnType<typeof universalTypedQueryInstructors>;
  function overloadedQuery(query?: InstructorQuery): any {
    return router(...arguments);
  }

  return overloadedQuery;
}

export const createInstructor: MaybeContext<
  BuildRESTFunction<typeof publicCreateInstructor> &
    typeof publicCreateInstructor
> = /*#__PURE__*/ createRESTModule(publicCreateInstructor);
export const inviteInstructor: MaybeContext<
  BuildRESTFunction<typeof publicInviteInstructor> &
    typeof publicInviteInstructor
> = /*#__PURE__*/ createRESTModule(publicInviteInstructor);
export const listInstructors: MaybeContext<
  BuildRESTFunction<typeof publicListInstructors> & typeof publicListInstructors
> = /*#__PURE__*/ createRESTModule(publicListInstructors);
export const updateInstructor: MaybeContext<
  BuildRESTFunction<typeof publicUpdateInstructor> &
    typeof publicUpdateInstructor
> = /*#__PURE__*/ createRESTModule(publicUpdateInstructor);
export const deleteInstructor: MaybeContext<
  BuildRESTFunction<typeof publicDeleteInstructor> &
    typeof publicDeleteInstructor
> = /*#__PURE__*/ createRESTModule(publicDeleteInstructor);
export const assignInstructorToProgram: MaybeContext<
  BuildRESTFunction<typeof publicAssignInstructorToProgram> &
    typeof publicAssignInstructorToProgram
> = /*#__PURE__*/ createRESTModule(publicAssignInstructorToProgram);
export const unassignInstructorFromProgram: MaybeContext<
  BuildRESTFunction<typeof publicUnassignInstructorFromProgram> &
    typeof publicUnassignInstructorFromProgram
> = /*#__PURE__*/ createRESTModule(publicUnassignInstructorFromProgram);
export const changeProgramInstructors: MaybeContext<
  BuildRESTFunction<typeof publicChangeProgramInstructors> &
    typeof publicChangeProgramInstructors
> = /*#__PURE__*/ createRESTModule(publicChangeProgramInstructors);
export const queryInstructors: MaybeContext<
  BuildRESTFunction<typeof customQueryInstructors> &
    typeof customQueryInstructors
> = /*#__PURE__*/ createRESTModule(customQueryInstructors);

export {
  Role,
  SortOrder,
  State,
  SiteCreatedContext,
  Namespace,
  DeleteStatus,
  WebhookIdentityType,
} from './achievements-instructors-v2-instructor-instructors.universal.js';
export {
  Instructor,
  Image,
  InstructorWasAssigned,
  InstructorWasUnassigned,
  CreateInstructorRequest,
  CreateInstructorResponse,
  InviteInstructorRequest,
  InviteInstructorResponse,
  ListInstructorsRequest,
  Paging,
  ListInstructorsResponse,
  PagingMetadataV2,
  Cursors,
  QueryInstructorsRequest,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Sorting,
  CursorPaging,
  QueryInstructorsResponse,
  CursorPagingMetadata,
  UpdateInstructorRequest,
  UpdateInstructorResponse,
  UpdateInstructorRoleRequest,
  UpdateInstructorRoleResponse,
  DeleteInstructorRequest,
  DeleteInstructorResponse,
  AssignInstructorToProgramRequest,
  AssignInstructorToProgramResponse,
  UnassignInstructorFromProgramRequest,
  UnassignInstructorFromProgramResponse,
  ChangeProgramInstructorsRequest,
  ChangeProgramInstructorsResponse,
  MetaSiteSpecialEvent,
  MetaSiteSpecialEventPayloadOneOf,
  Asset,
  SiteCreated,
  SiteTransferred,
  SiteDeleted,
  DeleteContext,
  SiteUndeleted,
  SitePublished,
  SiteUnpublished,
  SiteMarkedAsTemplate,
  SiteMarkedAsWixSite,
  ServiceProvisioned,
  ServiceRemoved,
  SiteRenamed,
  SiteHardDeleted,
  NamespaceChanged,
  StudioAssigned,
  StudioUnassigned,
  SiteUrlChanged,
  SitePurgedExternally,
  OdeditorAssigned,
  OdeditorUnassigned,
  PicassoAssigned,
  PicassoUnassigned,
  WixelAssigned,
  WixelUnassigned,
  StudioTwoAssigned,
  StudioTwoUnassigned,
  UserDomainMediaEnabled,
  UserDomainMediaDisabled,
  Empty,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  PolicyAssignedToContributor,
  NoUserIdInCallScopeErrorDetails,
  PolicyRemovedFromContributor,
  PolicyUpdatedForContributor,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  CreateInstructorOptions,
  ListInstructorsOptions,
  InstructorsQueryResult,
  InstructorsQueryBuilder,
  InstructorQuerySpec,
  UpdateInstructor,
  UpdateInstructorOptions,
  DeleteInstructorOptions,
  AssignInstructorToProgramOptions,
  UnassignInstructorFromProgramOptions,
  ChangeProgramInstructorsOptions,
} from './achievements-instructors-v2-instructor-instructors.universal.js';
export {
  RoleWithLiterals,
  SortOrderWithLiterals,
  StateWithLiterals,
  SiteCreatedContextWithLiterals,
  NamespaceWithLiterals,
  DeleteStatusWithLiterals,
  WebhookIdentityTypeWithLiterals,
  UpdateInstructorApplicationErrors,
  ChangeProgramInstructorsApplicationErrors,
  CommonQueryWithEntityContext,
  InstructorQuery,
} from './achievements-instructors-v2-instructor-instructors.universal.js';
